import { Dispatch } from 'redux';
import actionTypes from 'redux/actions/actionTypes';
import { axiosV1, axiosV2 } from 'interceptors/axios';

import { Share } from 'types';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

import alertBodyTypes from 'modules/_shared/components/Alert/alertBodyTypes';
import { addAlert } from '../../_shared/redux/alertActions';

type GetSharesProps = {
  partnerId: string;
  page: number;
  items: number;
  searchTerm?: string | number;
  sortBy?: string;
  sortOrder?: string;
};

export const getShares =
  ({ ...params }: GetSharesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const query = { params: { ...params } };
      const { data } = await axiosV2.get(`/shares`, query);
      const decodedData = await decryptResponse(data);

      dispatch({
        type: actionTypes.GET_SHARES,
        shares: decodedData,
      });

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };

export const setShares = (shares: Share[]) => (dispatch: Dispatch) => {
  dispatch({
    type: actionTypes.SET_SHARES,
    shares,
  });
};

export const updateShare =
  (
    share: Partial<Share> & {
      method: string;
    }
  ) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV1.put(`/shares`, {
        _id: share._id,
        tag: share.tag,
        encumbrances: share.encumbrances,
        method: share.method,
      });
      const decodedData = await decryptResponse(data);

      dispatch({
        type: actionTypes.UPDATE_SHARE,
        share: decodedData,
      });

      dispatch(addAlert(alertBodyTypes.SHARE_UPDATED));
      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
